export default {
    init($){
        console.log('login.js');

        let switchButton = $('.login-form-switcher button');

        switchButton.click(function (e) {
            e.preventDefault();
            $('#customer_login').toggleClass('is_registration');
        });

        // let html = '<span class="woocommerce-LostPassword lost_password"> <a class="pull-right" href="/cadastro-empresa">Empresa? clique aqui</a> </span>';
        // let labelCpf = $('.woocommerce-account .woocommerce-form-register label[for="billing_cpf"]');
        // if (labelCpf.length){
        //     labelCpf.append(html);
        // }

    }
}